import React, { useEffect, useRef, useState } from "react";
import Tick from "../assets/tick.png";
import Arrow from "../assets/arrow.png";
import Logo from "../assets/logo.png";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

function numberToWordsAED(numStr) {
    const ones = [
        "", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE",
        "TEN", "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN",
        "SEVENTEEN", "EIGHTEEN", "NINETEEN",
    ];
    const tens = ["", "", "TWENTY", "THIRTY", "FORTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY"];

    function convertHundreds(n) {
        let str = "";
        if (n >= 100) {
            str += ones[Math.floor(n / 100)] + " HUNDRED";
            n %= 100;
            if (n > 0) str += " ";
        }
        if (n >= 20) {
            str += tens[Math.floor(n / 10)];
            n %= 10;
            if (n > 0) str += " " + ones[n];
        } else if (n > 0) {
            str += ones[n];
        }
        return str;
    }

    function convert(n) {
        if (n === 0) return "ZERO";
        let str = "";
        if (n >= 1000000) {
            str += convert(Math.floor(n / 1000000)) + " MILLION";
            n %= 1000000;
            if (n > 0) str += " ";
        }
        if (n >= 1000) {
            str += convertHundreds(Math.floor(n / 1000)) + " THOUSAND";
            n %= 1000;
            if (n > 0) str += " ";
        }
        if (n > 0) {
            str += convertHundreds(n);
        }
        return str;
    }

    const num = parseFloat(numStr) || 0;
    const dirhams = Math.floor(num);
    const fils = Math.round((num - dirhams) * 100);

    let words = convert(dirhams);
    if (fils > 0) {
        words += " AND " + convert(fils) + " FILS";
    }
    words += " ONLY";
    return words;
}

const DEV_TEST_DATA = {
    paymentInProgress: "true",
    paymentType: "Net Banking",
    mobile: "971501234567",
    email: "test@example.com",
    amount: "159.390",
    acNo: "2018C0513",
    outstandingBalance: "0",
    customerName: "Jayesh Panchmatia/Tenant:Thias Sampaio Da Silva Pa",
    trans_id: "TEST-TXN-001",
};

function PaymentSuccessPage() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const isDevTest =
        process.env.NODE_ENV === "development" && searchParams.get("test") === "true";

    const trans_id = isDevTest ? DEV_TEST_DATA.trans_id : searchParams.get("trans_id");

    const [paymentInprogress] = useState(
        isDevTest ? DEV_TEST_DATA.paymentInProgress : localStorage.getItem("paymentInProgress")
    );
    const [paymentType] = useState(
        isDevTest ? DEV_TEST_DATA.paymentType : localStorage.getItem("paymentType")
    );
    const [mobile] = useState(
        isDevTest ? DEV_TEST_DATA.mobile : localStorage.getItem("mobile")
    );
    const [email] = useState(
        isDevTest ? DEV_TEST_DATA.email : localStorage.getItem("email")
    );
    const [amount] = useState(
        isDevTest ? DEV_TEST_DATA.amount : localStorage.getItem("amount")
    );
    const [acNo] = useState(
        isDevTest ? DEV_TEST_DATA.acNo : localStorage.getItem("acNo")
    );
    const [outstandingBalance] = useState(
        isDevTest ? DEV_TEST_DATA.outstandingBalance : localStorage.getItem("outstandingBalance")
    );
    const [customerName] = useState(
        isDevTest ? DEV_TEST_DATA.customerName : (localStorage.getItem("customerName") || "")
    );
    const [downloading, setDownloading] = useState(false);

    const receiptRef = useRef(null);

    const today = new Date();
    const receiptDate = `${String(today.getDate()).padStart(2, "0")}/${String(today.getMonth() + 1).padStart(2, "0")}/${today.getFullYear()}`;

    const sendSuccessMail = async () => {
        try {
            await axios.post(
                `${process.env.REACT_APP_API_BASE_URL}payment-gateway/send-sucess-mail?email=${email}&amount=${amount}&acNo=${acNo}&transcactionId=${trans_id}&phone=${mobile}&outstandingBalance=${outstandingBalance}`
            );
        } catch (error) {
            console.error("Error fetching customer details:", error);
        }
    };

    useEffect(() => {
        window.scrollTo({ top: 80, behavior: "smooth" });
    }, []);

    useEffect(() => {
        if (!isDevTest) {
            email && acNo && amount && trans_id && sendSuccessMail();
        }
    }, []);

    useEffect(() => {
        if (isDevTest) return;
        if (paymentInprogress === "true") {
            localStorage.removeItem("paymentInProgress");
            localStorage.removeItem("paymentType");
            localStorage.removeItem("mobile");
            localStorage.removeItem("email");
            localStorage.removeItem("amount");
            localStorage.removeItem("acNo");
            localStorage.removeItem("outstandingBalance");
            localStorage.removeItem("encryptData");
            localStorage.removeItem("customerName");
        } else {
            navigate("/");
        }
    }, []);

    const downloadReceipt = async () => {
        setDownloading(true);
        try {
            const element = receiptRef.current;
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                backgroundColor: "#ffffff",
            });
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
            const pageWidth = 210;
            const imgHeight = (canvas.height * pageWidth) / canvas.width;
            pdf.addImage(imgData, "PNG", 0, 0, pageWidth, imgHeight);
            pdf.save(`receipt-${trans_id || "download"}.pdf`);
        } catch (err) {
            console.error("PDF generation error:", err);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div>
                {isDevTest && (
                <div style={{ background: "#ffcc00", color: "#000", textAlign: "center", padding: "8px", fontWeight: "bold", fontSize: "13px" }}>
                    DEV TEST MODE — using dummy data, no mail sent
                </div>
            )}
            <section className="pay-success">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-sm-12">
                            <div className="div1 text-center">
                                <img src={Tick} className="img-fluid mb-4" alt="Success Tick" />
                                <h4>Payment Successful</h4>

                                <table width="60%" className="mx-auto pay-success-table">
                                    <tbody>
                                        <tr>
                                            <td>Payment Type</td>
                                            <td className="text-end">{paymentType}</td>
                                        </tr>
                                        <tr>
                                            <td>Mobile</td>
                                            <td className="text-end">
                                                {mobile && mobile.length > 3 ? mobile : ""}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>Email</td>
                                            <td className="text-end">{email}</td>
                                        </tr>
                                        <tr height="50px">
                                            <td><b>Amount Paid</b></td>
                                            <td className="text-end"><b>AED {amount}</b></td>
                                        </tr>
                                        <tr>
                                            <td>Transaction Id</td>
                                            <td className="text-end">{trans_id}</td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div style={{ marginTop: "50px", display: "flex", justifyContent: "center", gap: "30px", alignItems: "center", flexWrap: "wrap" }}>
                                    <a href="https://www.uticome.com/">
                                        <img src={Arrow} className="img-fluid" alt="Back to Home Arrow" />{" "}
                                        Back To Home
                                    </a>
                                    <button
                                        onClick={downloadReceipt}
                                        disabled={downloading}
                                        style={{
                                            backgroundColor: "#1b7daa",
                                            color: "#fff",
                                            border: "none",
                                            padding: "10px 24px",
                                            borderRadius: "6px",
                                            cursor: downloading ? "not-allowed" : "pointer",
                                            fontSize: "14px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {downloading ? "Generating..." : "Download Receipt"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Hidden receipt template for PDF generation */}
            <div style={{ position: "absolute", left: "-9999px", top: 0 }}>
                <div
                    ref={receiptRef}
                    style={{
                        width: "794px",
                        padding: "40px 50px",
                        backgroundColor: "#ffffff",
                        fontFamily: "Arial, sans-serif",
                        fontSize: "14px",
                        color: "#000",
                        border: "2px solid #ccc",
                    }}
                >
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "24px" }}>
                        <img src={Logo} style={{ height: "70px", objectFit: "contain" }} alt="Utico Logo" crossOrigin="anonymous" />
                        <h2 style={{ textDecoration: "underline", fontWeight: "bold", margin: 0, fontSize: "22px" }}>
                            Online Receipt
                        </h2>
                        <div style={{ textAlign: "right" }}>
                            <span><strong>Date: </strong></span>
                            <span style={{ textDecoration: "underline", fontWeight: "bold" }}>{receiptDate}</span>
                        </div>
                    </div>

                    {/* Account number */}
                    <div style={{ marginBottom: "16px" }}>
                        <strong>CONSUMER ACCOUNT NO: <span style={{ textDecoration: "underline" }}>{acNo}</span></strong>
                    </div>

                    {/* Body text */}
                    <p style={{ marginBottom: "24px", lineHeight: "1.6" }}>
                        Received with Thanks from M/s.
                        <strong style={{ textDecoration: "underline" }}>{customerName}</strong>{" "}
                        a sum of AED <strong style={{ textDecoration: "underline" }}>{amount}</strong>{" "}
                        (AED{" "}
                        <strong style={{ textDecoration: "underline" }}>
                            {numberToWordsAED(amount)}
                        </strong>{" "}
                        only) towards the Invoice
                    </p>

                    {/* Payment table */}
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            marginBottom: "24px",
                        }}
                    >
                        <thead>
                            <tr>
                                <th style={{ border: "1px solid #000", padding: "10px 16px", textAlign: "center", fontWeight: "bold" }}>
                                    Payment mode
                                </th>
                                <th style={{ border: "1px solid #000", padding: "10px 16px", textAlign: "center", fontWeight: "bold" }}>
                                    Payment Status
                                </th>
                                <th style={{ border: "1px solid #000", padding: "10px 16px", textAlign: "center", fontWeight: "bold" }}>
                                    Amount (AED)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td style={{ border: "1px solid #000", padding: "10px 16px", textAlign: "center" }}>
                                    Online
                                </td>
                                <td style={{ border: "1px solid #000", padding: "10px 16px", textAlign: "center" }}>
                                    Success
                                </td>
                                <td style={{ border: "1px solid #000", padding: "10px 16px", textAlign: "center" }}>
                                    {amount}
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* AED total box */}
                    <div style={{ marginBottom: "80px" }}>
                        <div
                            style={{
                                display: "inline-block",
                                border: "1px solid #000",
                                padding: "8px 16px",
                                fontWeight: "bold",
                            }}
                        >
                            AED . {amount}
                        </div>
                    </div>

                    {/* Separator */}
                    <hr style={{ border: "none", borderTop: "1px solid #000", marginBottom: "20px" }} />

                    {/* Footer */}
                    <div style={{ textAlign: "center", fontSize: "13px" }}>
                        <p style={{ margin: "0 0 6px 0", fontWeight: "bold" }}>
                            P.O.Box : 54527 , RAK , U.A.E , Phone : +971 7 243 4610/11 , Fax : +971 7 243 4612 , Email : info@uticome.com
                        </p>
                        <p style={{ margin: "0 0 6px 0", fontWeight: "bold" }}>
                            Website : www.uticome.com
                        </p>
                        <p style={{ margin: 0, fontWeight: "bold" }}>
                            THIS DOCUMENT IS COMPUTER GENERATED AND REQUIRES NO SIGNATURE &amp; COMPANY STAMP
                        </p>
                    </div>
                </div>
            </div>

            <script src="https://code.jquery.com/jquery-3.5.1.slim.min.js"></script>
            <script src="https://cdn.jsdelivr.net/npm/@popperjs/core@2.5.3/dist/umd/popper.min.js"></script>
            <script src="https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/js/bootstrap.min.js"></script>
        </div>
    );
}

export default PaymentSuccessPage;
